/** Presentation only. The review screen is the final step; no route or validation changes. */
export function guidedProgress(s: {
  task: string | null;
  review: boolean;
  editing: boolean;
  passportStep: number;
  passportCount: number;
  passportException: boolean;
  personalStep: number;
  personalCount: number;
  workStep: number;
  workCount: number;
  immigrationStep: number;
  immigrationCount: number;
  professionalStep: number;
  professionalCount: number;
  builderStep: number;
  savedProfile: boolean;
}): { current: number; total: number } | null {
  if (s.editing) return null;
  if (s.task === "profile_assistant") return s.savedProfile ? null : { current: s.builderStep === 5 ? 1 : s.builderStep === 4 ? 3 : 2, total: 3 };
  const flow: Record<string, [number, number]> = {
    passport: [s.passportStep, s.passportCount],
    contact_details: [s.personalStep + 1, s.personalCount],
    engagement: [s.workStep + 1, s.workCount],
    immigration_history: [s.immigrationStep + 1, s.immigrationCount],
    professional_profile: [s.professionalStep + 1, s.professionalCount],
  };
  const counts = s.task ? flow[s.task] : undefined;
  if (!counts || (s.task === "passport" && (s.passportException || s.passportStep === 0))) return null;
  const total = counts[1] + 1;
  return { current: s.review ? total : counts[0], total };
}
